import { render, staticRenderFns } from "./MessengerTrigger.vue?vue&type=template&id=0d99cdae&"
import script from "./MessengerTrigger.vue?vue&type=script&lang=js&"
export * from "./MessengerTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports